import i18n from '@/lang/i18n'

export default {
    title: i18n.t('configuration.elementTitle.centersAndServices'),
    id: 'centersAndServices',
    sidebar: [
        {
            id: 'healthManagementArea',
            label: i18n.tc('configuration.sections.healthManagementArea', 2),
            icon: 'fal fa-first-aid',
            routeName: 'HealthManagementArea',
            hasChildren: false
        },
        {
            id: 'centers',
            label: i18n.tc('configuration.sections.center', 2),
            icon: 'fal fa-hospital',
            routeName: 'Centers',
            hasChildren: false
        },
        {
            id: 'departmentsTypes',
            label: i18n.tc('configuration.sections.departmentType', 2),
            icon: 'fal fa-list-ul',
            routeName: 'DepartmentsTypes',
            hasChildren: false
        },
        {
            id: 'departments',
            label: i18n.tc('configuration.sections.department', 2),
            icon: 'fal fa-clinic-medical',
            routeName: 'Departments',
            hasChildren: false
        }
    ]
}
